export default __webpack_public_path__ + "static/media/usr.10dea3ac.png";